<template>
  <div>
    <v-container>
      <v-form>
        <v-row>
          <v-col>
            <h2 class="pb-5">{{ this.pageTitle }}</h2>
          </v-col>
        </v-row>

        <!-- <v-container
          id="scroll-target"
          class="custom-form overflow-y-auto px-5"
        > -->
        <!-- <v-row>
            <v-col cols="6" sm="6" class="blue--text ml-2">Export Process Log</v-col>
          </v-row>-->

        <v-container>
          <v-row>
            <v-col cols="6" sm="6" class="orange lighten-5">
              <v-row>
                <v-col cols="4" sm="4">
                  <v-text-field
                    :label="this.$t('latenessdeduction.totalrecordsprocessed')"
                    type="text"
                    v-model="listErr.processed"
                    class="custom"
                    readonly
                    dense
                    background-color="#FFF3E0"
                  ></v-text-field>
                </v-col>
                <v-col cols="4" sm="4">
                  <v-text-field
                    :label="this.$t('latenessdeduction.totalrecordsposted')"
                    type="text"
                    v-model="listErr.inserted"
                    class="custom"
                    readonly
                    dense
                    background-color="#FFF3E0"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="4" sm="4">
                  <v-text-field
                    :label="this.$t('processclockdatarecord.staffcount')"
                    type="text"
                    v-model="listErr.count"
                    class="custom"
                    readonly
                    dense
                    background-color="#FFF3E0"
                  ></v-text-field>
                </v-col>
                <v-col cols="4" sm="4">
                  <v-text-field
                    :label="this.$t('columns.totalamount')"
                    type="text"
                    v-model="listErr.amount"
                    class="custom"
                    readonly
                    dense
                    background-color="#FFF3E0"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
        <!-- </v-container> -->
        <v-row>
          <div class="pt-5 pl-4">
            <v-btn color="warning" style="width: 100px" @click="returnHandler"
              >{{$t('button.back')}}</v-btn
            >
          </div>
        </v-row>
      </v-form>
    </v-container>
    <div v-if="isErr">
      <app-error
        v-bind:parentError="{
          data: this.errMsg,
          isErr: this.isErr,
        }"
        v-on:closeError="isErr = $event"
      />
    </div>
  </div>
</template>

<script>
// import axios from "axios";
import ErrorDialog from "../../../components/common/ErrorDialog";

export default {
  components: {
    "app-error": ErrorDialog,
  },

  data() {
    return {
      publicPath: process.env.BASE_URL,
      rules: {
        required: (value) => !!value || this.$t('reportsparam.required'),
      },
      pageTitle: this.$t('latenessdeduction.postinglog'),
      listErr: {
        inserted: this.$route.params.inserted,
        processed: this.$route.params.processed,
        count: this.$route.params.count,
        amount: this.$route.params.amount,
      },
      errMsg: "",
      isErr: false,
    };
  },

  methods: {
    returnHandler() {
      this.$router.push({ name: "latenessdeductionposting" });
    },
  },
  mounted() {},
};
</script>